<div class="settings-wrapper">
  <p>Du heter <b>{{ user.username }}</b> och har e-mail <b>{{ user.email }}</b> </p>
  <p>Dina roller: <b>{{ user.roles.join(', ') }}</b></p>
  <p>Klientversion: <b>{{ appVersion }}</b></p>
  <div class="user">
    <p>{{ user.username }}</p>
    <div class="logout">
      <button mat-raised-button (click)="authService.logout()">Logga ut</button>
    </div>
  </div>

  <div class="release-notes-content">
    <h4>Ändringslogg</h4>
    <mat-card appearance="outlined" class="settings-card">
      <mat-card-content class="settings-card-content">
        <div class="version-wrapper">
          @for(releaseNote of releaseNotes; track releaseNote) {
          <div class="version">Version {{ releaseNote.release }}</div>
          @for (content of releaseNote.contents; track content) {
          <div>
            <div class="note-title">{{ content.title }}</div>
            <ul class="note-list">
              <div>
                @for (note of content.notes; track note) {
                <li>{{ note.note }}</li>
                }
              </div>
            </ul>
          </div>
          }
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>